import * as React from 'react';

export const Campaigns = React.createContext([]);
